import React, { useState, useEffect } from 'react';
import './BMTCFaqs.css';

export default function BMTCFaq() {
  const [lang, setLang] = useState('en');

  useEffect(() => {
    // Load saved language preference or check URL query params
    try {
      const saved = localStorage.getItem('bmtc-faq-lang') || 'en';
      const q = new URLSearchParams(window.location.search).get('lang');
      if (q === 'kn' || q === 'en') {
        setLang(q);
      } else {
        setLang(saved);
      }
    } catch (e) {
      setLang('en');
    }

    // Handle hash on load
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el && el.tagName === 'DETAILS') {
        el.open = true;
      }
    }
  }, []);

  const handleLangChange = (selectedLang) => {
    setLang(selectedLang);
    try {
      localStorage.setItem('bmtc-faq-lang', selectedLang);
    } catch (e) {}
  };

  const handleJumpLink = (targetId, e) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="bmtc-faq-container" data-lang={lang}>
      <header>
        <div className="wrap top">
          <div className="brand">
            <div className="seal">BMTC</div>
            <div>
              <h1>
                <span lang="en">Namma BMTC App – Help &amp; FAQs</span>
                <span lang="kn">ನಮ್ಮ BMTC ಆ್ಯಪ್ – ಸಹಾಯ ಮತ್ತು ಪ್ರಶ್ನೋತ್ತರಗಳು</span>
              </h1>
              <p>
                <span lang="en">Tickets, Mobile Wallet, passes and payments</span>
                <span lang="kn">ಟಿಕೆಟ್, ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್, ಪಾಸ್ ಮತ್ತು ಪಾವತಿಗಳು</span>
              </p>
            </div>
          </div>
          <div className="langs" role="group" aria-label="Language">
            <button
              data-lang="en"
              className={lang === 'en' ? 'on' : ''}
              onClick={() => handleLangChange('en')}
            >
              English
            </button>
            <button
              data-lang="kn"
              className={lang === 'kn' ? 'on' : ''}
              onClick={() => handleLangChange('kn')}
            >
              ಕನ್ನಡ
            </button>
          </div>
        </div>
      </header>

      <div className="wrap intro">
        <p>
          <span lang="en">Answers to the most common questions about paying for tickets, using the Mobile Wallet and buying passes on the Namma BMTC app. Tap a question to see the answer.</span>
          <span lang="kn">ನಮ್ಮ BMTC ಆ್ಯಪ್‌ನಲ್ಲಿ ಟಿಕೆಟ್ ಪಾವತಿ, ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್ ಬಳಕೆ ಮತ್ತು ಪಾಸ್ ಖರೀದಿ ಕುರಿತ ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳಿಗೆ ಉತ್ತರಗಳು. ಉತ್ತರ ನೋಡಲು ಪ್ರಶ್ನೆಯನ್ನು ಒತ್ತಿ.</span>
        </p>
      </div>

      <nav className="wrap toc">
        <a className="jumplink" onClick={(e) => handleJumpLink('tickets', e)} tabIndex="0" role="link">
          <b>
            <span lang="en">Mobile Tickets</span>
            <span lang="kn">ಮೊಬೈಲ್ ಟಿಕೆಟ್‌ಗಳು</span>
          </b>
          <small>
            <span lang="en">Paying for your bus ticket with the Namma BMTC app</span>
            <span lang="kn">ನಮ್ಮ BMTC ಆ್ಯಪ್ ಮೂಲಕ ಬಸ್ ಟಿಕೆಟ್‌ಗೆ ಪಾವತಿ ಮಾಡುವುದು</span>
          </small>
        </a>
        <a className="jumplink" onClick={(e) => handleJumpLink('wallet', e)} tabIndex="0" role="link">
          <b>
            <span lang="en">Mobile Wallet</span>
            <span lang="kn">ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್</span>
          </b>
          <small>
            <span lang="en">The prepaid balance inside the app that pays for tickets and passes</span>
            <span lang="kn">ಟಿಕೆಟ್ ಮತ್ತು ಪಾಸ್‌ಗಳಿಗೆ ಪಾವತಿಸುವ ಆ್ಯಪ್‌ನೊಳಗಿನ ಪ್ರೀಪೇಯ್ಡ್ ಬ್ಯಾಲೆನ್ಸ್</span>
          </small>
        </a>
        <a className="jumplink" onClick={(e) => handleJumpLink('passes', e)} tabIndex="0" role="link">
          <b>
            <span lang="en">Bus Passes</span>
            <span lang="kn">ಬಸ್ ಪಾಸ್‌ಗಳು</span>
          </b>
          <small>
            <span lang="en">Buying and using daily, weekly and monthly passes in the app</span>
            <span lang="kn">ಆ್ಯಪ್‌ನಲ್ಲಿ ದೈನಿಕ, ವಾರದ ಮತ್ತು ಮಾಸಿಕ ಪಾಸ್‌ಗಳನ್ನು ಖರೀದಿಸುವುದು ಮತ್ತು ಬಳಸುವುದು</span>
          </small>
        </a>
        <a className="jumplink" onClick={(e) => handleJumpLink('payments', e)} tabIndex="0" role="link">
          <b>
            <span lang="en">Payment Issues and Refunds</span>
            <span lang="kn">ಪಾವತಿ ಸಮಸ್ಯೆಗಳು ಮತ್ತು ಮರುಪಾವತಿ</span>
          </b>
          <small>
            <span lang="en">What to do when a payment fails, money is deducted, or a refund is late</span>
            <span lang="kn">ಪಾವತಿ ವಿಫಲವಾದಾಗ, ಹಣ ಕಡಿತವಾದಾಗ ಅಥವಾ ಮರುಪಾವತಿ ತಡವಾದಾಗ ಏನು ಮಾಡಬೇಕು</span>
          </small>
        </a>
      </nav>

      <main className="wrap">
        {/* Section: Tickets */}
        <section id="tickets">
          <h2>
            <span lang="en">Mobile Tickets</span>
            <span lang="kn">ಮೊಬೈಲ್ ಟಿಕೆಟ್‌ಗಳು</span>
          </h2>
          <p className="blurb">
            <span lang="en">Paying for your bus ticket with the Namma BMTC app</span>
            <span lang="kn">ನಮ್ಮ BMTC ಆ್ಯಪ್ ಮೂಲಕ ಬಸ್ ಟಿಕೆಟ್‌ಗೆ ಪಾವತಿ ಮಾಡುವುದು</span>
          </p>

          <details id="tickets-1">
            <summary>
              <span lang="en">How do I buy a bus ticket on the Namma BMTC app?</span>
              <span lang="kn">ನಮ್ಮ BMTC ಆ್ಯಪ್‌ನಲ್ಲಿ ಬಸ್ ಟಿಕೆಟ್ ಹೇಗೆ ಖರೀದಿಸುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>There are two ways to buy a ticket in the app.</p>
                <p><strong>Option 1: QuickPay</strong> (wallet payment — use this after boarding)</p>
                <ul>
                  <li>On the home screen, tap <strong>QuickPay</strong> under Quick Payments.</li>
                  <li>Ask the conductor for the fare amount and enter it in the app.</li>
                  <li>Tap <strong>Pay the conductor</strong>, check the amount and your wallet balance, and tap <strong>Confirm payment</strong>.</li>
                  <li>The amount is deducted from your Mobile Wallet.</li>
                </ul>
                <p><strong>Option 2: Find fare</strong> (can be booked ahead of time)</p>
                <ul>
                  <li>Tap <strong>Find fare</strong>, then enter your from and to stop and select the route.</li>
                  <li>The fare for that journey is shown. Pay using your Mobile Wallet, or with an online mode such as UPI or a card.</li>
                </ul>
                <p>Recharging your Mobile Wallet needs an internet connection, but once it's recharged, paying with the wallet balance can work even without internet.</p>
              </div>
              <div lang="kn">
                <p>ಆ್ಯಪ್‌ನಲ್ಲಿ ಟಿಕೆಟ್ ಖರೀದಿಸಲು ಎರಡು ವಿಧಾನಗಳಿವೆ.</p>
                <p><strong>ಆಯ್ಕೆ 1: QuickPay</strong> (ವ್ಯಾಲೆಟ್ ಪಾವತಿ — ಬಸ್ ಹತ್ತಿದ ನಂತರ ಬಳಸಿ)</p>
                <ul>
                  <li>ಮುಖಪುಟದಲ್ಲಿ, Quick Payments ಅಡಿಯಲ್ಲಿ <strong>QuickPay</strong> ಅನ್ನು ಒತ್ತಿ.</li>
                  <li>ಕಂಡಕ್ಟರ್ ಅವರನ್ನು ಟಿಕೆಟ್ ದರ ಕೇಳಿ, ಆ ಮೊತ್ತವನ್ನು ಆ್ಯಪ್‌ನಲ್ಲಿ ನಮೂದಿಸಿ.</li>
                  <li><strong>Pay the conductor</strong> ಒತ್ತಿ, ಮೊತ್ತ ಮತ್ತು ನಿಮ್ಮ ವ್ಯಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಪರಿಶೀಲಿಸಿ, ನಂತರ <strong>Confirm payment</strong> ಒತ್ತಿ.</li>
                  <li>ಮೊತ್ತವು ನಿಮ್ಮ ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ನಿಂದ ಕಡಿತವಾಗುತ್ತದೆ.</li>
                </ul>
                <p><strong>ಆಯ್ಕೆ 2: Find fare</strong> (ಮುಂಚಿತವಾಗಿ ಬುಕ್ ಮಾಡಬಹುದು)</p>
                <ul>
                  <li><strong>Find fare</strong> ಒತ್ತಿ, ನಂತರ ನಿಮ್ಮ ಆರಂಭ ಮತ್ತು ಗಮ್ಯ ನಿಲ್ದಾಣ ನಮೂದಿಸಿ, ಮಾರ್ಗ ಆಯ್ಕೆ ಮಾಡಿ.</li>
                  <li>ಆ ಪ್ರಯಾಣದ ದರ ಕಾಣಿಸುತ್ತದೆ. ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್ ಮೂಲಕ ಅಥವಾ UPI, ಕಾರ್ಡ್‌ನಂತಹ ಆನ್‌ಲೈನ್ ವಿಧಾನದ ಮೂಲಕ ಪಾವತಿಸಿ.</li>
                </ul>
                <p>ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್ ರೀಚಾರ್ಜ್‌ಗೆ ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕ ಬೇಕು, ಆದರೆ ಒಮ್ಮೆ ರೀಚಾರ್ಜ್ ಆದ ನಂತರ, ವ್ಯಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್‌ನಿಂದ ಪಾವತಿ ಮಾಡುವುದು ಇಂಟರ್ನೆಟ್ ಇಲ್ಲದೆಯೂ ಕೆಲಸ ಮಾಡಬಹುದು.</p>
              </div>
            </div>
          </details>

          <details id="tickets-2">
            <summary>
              <span lang="en">I have paid. How do I get my ticket?</span>
              <span lang="kn">ನಾನು ಪಾವತಿ ಮಾಡಿದ್ದೇನೆ. ಟಿಕೆಟ್ ಹೇಗೆ ಪಡೆಯುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Tap <strong>Validate now</strong> and show your phone to the conductor. The conductor scans the QR code shown on your screen using the ticket machine, and your ticket is issued in the app.</p>
                <p>Your ticket is issued only after the conductor validates it. Do not close the app until you see the ticket.</p>
              </div>
              <div lang="kn">
                <p><strong>Validate now</strong> ಒತ್ತಿ, ನಿಮ್ಮ ಫೋನ್ ಅನ್ನು ಕಂಡಕ್ಟರ್‌ಗೆ ತೋರಿಸಿ. ಕಂಡಕ್ಟರ್ ನಿಮ್ಮ ಪರದೆಯಲ್ಲಿ ಕಾಣಿಸುವ QR ಕೋಡ್ ಅನ್ನು ಟಿಕೆಟ್ ಯಂತ್ರದಿಂದ ಸ್ಕ್ಯಾನ್ ಮಾಡಿದ ನಂತರ, ನಿಮ್ಮ ಟಿಕೆಟ್ ಆ್ಯಪ್‌ನಲ್ಲಿ ನೀಡಲಾಗುತ್ತದೆ.</p>
                <p>ಕಂಡಕ್ಟರ್ ಮಾನ್ಯ ಮಾಡಿದ ನಂತರವೇ ಟಿಕೆಟ್ ನೀಡಲಾಗುತ್ತದೆ. ಟಿಕೆಟ್ ಕಾಣುವವರೆಗೆ ಆ್ಯಪ್ ಮುಚ್ಚಬೇಡಿ.</p>
              </div>
            </div>
          </details>

          <details id="tickets-3">
            <summary>
              <span lang="en">When should I pay: before or after boarding the bus?</span>
              <span lang="kn">ಬಸ್ ಹತ್ತುವ ಮೊದಲು ಪಾವತಿಸಬೇಕೇ ಅಥವಾ ನಂತರವೇ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>It depends which option you use.</p>
                <ul>
                  <li><strong>QuickPay</strong> (entering the fare the conductor gives you): pay <strong>after boarding</strong>, when the conductor comes to you. If the conductor is unable to validate it, the amount is returned to your Mobile Wallet within 24 hours.</li>
                  <li><strong>Find fare</strong> (selecting your route): this can be booked ahead of time, so you can pay in advance for a planned trip.</li>
                </ul>
              </div>
              <div lang="kn">
                <p>ಇದು ನೀವು ಯಾವ ಆಯ್ಕೆ ಬಳಸುತ್ತೀರಿ ಎಂಬುದರ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿದೆ.</p>
                <ul>
                  <li><strong>QuickPay</strong> (ಕಂಡಕ್ಟರ್ ಹೇಳುವ ದರ ನಮೂದಿಸುವುದು): <strong>ಬಸ್ ಹತ್ತಿದ ನಂತರ</strong>, ಕಂಡಕ್ಟರ್ ನಿಮ್ಮ ಬಳಿ ಬಂದಾಗ ಪಾವತಿಸಿ. ಕಂಡಕ್ಟರ್ ಮಾನ್ಯ ಮಾಡಲು ಸಾಧ್ಯವಾಗದಿದ್ದರೆ, ಮೊತ್ತವು 24 ಗಂಟೆಗಳೊಳಗೆ ನಿಮ್ಮ ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂತಿರುಗುತ್ತದೆ.</li>
                  <li><strong>Find fare</strong> (ಮಾರ್ಗ ಆಯ್ಕೆ ಮಾಡುವುದು): ಇದನ್ನು ಮುಂಚಿತವಾಗಿ ಬುಕ್ ಮಾಡಬಹುದು, ಆದ್ದರಿಂದ ಯೋಜಿತ ಪ್ರಯಾಣಕ್ಕೆ ಮುಂಚಿತವಾಗಿ ಪಾವತಿಸಬಹುದು.</li>
                </ul>
              </div>
            </div>
          </details>

          <details id="tickets-4">
            <summary>
              <span lang="en">Can I pay for more than one passenger?</span>
              <span lang="kn">ಒಂದಕ್ಕಿಂತ ಹೆಚ್ಚು ಪ್ರಯಾಣಿಕರಿಗೆ ಪಾವತಿಸಬಹುದೇ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Yes, but how you do it depends on the option.</p>
                <ul>
                  <li><strong>QuickPay</strong>: tell the conductor how many passengers are travelling and where to, and enter the <strong>total fare</strong> the conductor gives you.</li>
                  <li><strong>Find fare</strong>: after selecting your route, select the <strong>number of passengers</strong>, and the app calculates the total fare for the group.</li>
                </ul>
                <p>One ticket is issued for the group after validation.</p>
              </div>
              <div lang="kn">
                <p>ಹೌದು, ಆದರೆ ಇದು ಆಯ್ಕೆಯ ಮೇಲೆ ಅವಲಂಬಿತವಾಗಿದೆ.</p>
                <ul>
                  <li><strong>QuickPay</strong>: ಎಷ್ಟು ಪ್ರಯಾಣಿಕರು ಮತ್ತು ಎಲ್ಲಿಗೆ ಎಂದು ಕಂಡಕ್ಟರ್‌ಗೆ ತಿಳಿಸಿ, ಕಂಡಕ್ಟರ್ ಹೇಳುವ <strong>ಒಟ್ಟು ದರ</strong>ವನ್ನು ನಮೂದಿಸಿ.</li>
                  <li><strong>Find fare</strong>: ಮಾರ್ಗ ಆಯ್ಕೆ ಮಾಡಿದ ನಂತರ, <strong>ಪ್ರಯಾಣಿಕರ ಸಂಖ್ಯೆ</strong>ಯನ್ನು ಆಯ್ಕೆ ಮಾಡಿ, ಆ್ಯಪ್ ಗುಂಪಿಗೆ ಒಟ್ಟು ದರವನ್ನು ಲೆಕ್ಕಹಾಕುತ್ತದೆ.</li>
                </ul>
                <p>ಮಾನ್ಯ ಮಾಡಿದ ನಂತರ ಎಲ್ಲರಿಗೂ ಸೇರಿ ಒಂದೇ ಟಿಕೆಟ್ ನೀಡಲಾಗುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="tickets-5">
            <summary>
              <span lang="en">My payment shows "In Process". What does that mean?</span>
              <span lang="kn">ನನ್ನ ಪಾವತಿ "In Process" ಎಂದು ತೋರಿಸುತ್ತಿದೆ. ಇದರ ಅರ್ಥವೇನು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>"In Process" means the app is waiting for the conductor's machine to confirm the ticket. This applies to <strong>QuickPay</strong> payments, and normally clears within a few minutes once the conductor validates your payment.</p>
                <p>If the ticket is not issued, the amount is returned to your Mobile Wallet within 24 hours and the transaction shows as <strong>Returned</strong> in My Transactions.</p>
              </div>
              <div lang="kn">
                <p>"In Process" ಎಂದರೆ ಕಂಡಕ್ಟರ್ ಯಂತ್ರದಿಂದ ಟಿಕೆಟ್ ದೃಢೀಕರಣಕ್ಕಾಗಿ ಆ್ಯಪ್ ಕಾಯುತ್ತಿದೆ ಎಂದರ್ಥ. ಇದು <strong>QuickPay</strong> ಪಾವತಿಗಳಿಗೆ ಅನ್ವಯಿಸುತ್ತದೆ, ಮತ್ತು ಕಂಡಕ್ಟರ್ ನಿಮ್ಮ ಪಾವತಿಯನ್ನು ಮಾನ್ಯ ಮಾಡಿದ ಕೆಲವೇ ನಿಮಿಷಗಳಲ್ಲಿ ಇದು ಸಾಮಾನ್ಯವಾಗಿ ಪೂರ್ಣಗೊಳ್ಳುತ್ತದೆ.</p>
                <p>ಟಿಕೆಟ್ ನೀಡದಿದ್ದರೆ, ಮೊತ್ತವು 24 ಗಂಟೆಗಳೊಳಗೆ ನಿಮ್ಮ ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂತಿರುಗುತ್ತದೆ ಮತ್ತು My Transactions ನಲ್ಲಿ <strong>Returned</strong> ಎಂದು ತೋರಿಸುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="tickets-6">
            <summary>
              <span lang="en">The conductor could not validate my payment and I had to buy a paper ticket.</span>
              <span lang="kn">ಕಂಡಕ್ಟರ್ ನನ್ನ ಪಾವತಿಯನ್ನು ಮಾನ್ಯ ಮಾಡಲಾಗಲಿಲ್ಲ, ನಾನು ಕಾಗದದ ಟಿಕೆಟ್ ಖರೀದಿಸಬೇಕಾಯಿತು.</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>This can happen because of a temporary issue with the conductor's ticket machine.</p>
                <ul>
                  <li>If you paid using <strong>QuickPay</strong>, the amount is returned to your Mobile Wallet automatically, within 24 hours.</li>
                  <li>If you paid using <strong>Find fare</strong>, that amount is not refundable.</li>
                </ul>
                <p>If a wallet refund has not come back after 24 hours, write to <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> with:</p>
                <ul>
                  <li>A screenshot of the payment from My Transactions</li>
                  <li>A photo of the paper ticket you bought</li>
                  <li>Bus number, route number, date and time of travel</li>
                </ul>
                <p>BMTC will check the transaction and return the amount if it was not already reversed.</p>
              </div>
              <div lang="kn">
                <p>ಕಂಡಕ್ಟರ್ ಟಿಕೆಟ್ ಯಂತ್ರದಲ್ಲಿನ ತಾತ್ಕಾಲಿಕ ಸಮಸ್ಯೆಯಿಂದ ಹೀಗಾಗಬಹುದು.</p>
                <ul>
                  <li><strong>QuickPay</strong> ಮೂಲಕ ಪಾವತಿಸಿದ್ದರೆ, ಮೊತ್ತವು ತಾನಾಗಿಯೇ 24 ಗಂಟೆಗಳೊಳಗೆ ನಿಮ್ಮ ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂತಿರುಗುತ್ತದೆ.</li>
                  <li><strong>Find fare</strong> ಮೂಲಕ ಪಾವತಿಸಿದ್ದರೆ, ಆ ಮೊತ್ತ ಮರುಪಾವತಿಯಾಗುವುದಿಲ್ಲ.</li>
                </ul>
                <p>ವ್ಯಾಲೆಟ್ ಮರುಪಾವತಿ 24 ಗಂಟೆಗಳ ನಂತರವೂ ಬಾರದಿದ್ದರೆ, ಈ ವಿವರಗಳೊಂದಿಗೆ <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> ಗೆ ಬರೆಯಿರಿ:</p>
                <ul>
                  <li>My Transactions ನಲ್ಲಿರುವ ಪಾವತಿಯ ಸ್ಕ್ರೀನ್‌ಶಾಟ್</li>
                  <li>ನೀವು ಖರೀದಿಸಿದ ಕಾಗದದ ಟಿಕೆಟ್‌ನ ಫೋಟೋ</li>
                  <li>ಬಸ್ ಸಂಖ್ಯೆ, ಮಾರ್ಗ ಸಂಖ್ಯೆ, ಪ್ರಯಾಣದ ದಿನಾಂಕ ಮತ್ತು ಸಮಯ</li>
                </ul>
                <p>BMTC ವಹಿವಾಟನ್ನು ಪರಿಶೀಲಿಸಿ, ಈಗಾಗಲೇ ಹಿಂತಿರುಗಿಸದಿದ್ದರೆ ಮೊತ್ತವನ್ನು ಹಿಂತಿರುಗಿಸುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="tickets-7">
            <summary>
              <span lang="en">The conductor refused to accept payment through the app.</span>
              <span lang="kn">ಕಂಡಕ್ಟರ್ ಆ್ಯಪ್ ಮೂಲಕ ಪಾವತಿ ಸ್ವೀಕರಿಸಲು ನಿರಾಕರಿಸಿದರು.</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>All BMTC conductors are required to accept payments made through the Namma BMTC app. If a conductor refuses, please report it to <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> or call <a href="tel:08022483777"><strong>080-22483777</strong></a> with the bus number, route number, date, time and boarding stop. The conductor's name or badge number, if you noticed it, helps BMTC act quickly.</p>
                <p>If you paid using <strong>QuickPay</strong> and it was not validated, that amount is returned to your Mobile Wallet automatically. Amounts paid via <strong>Find fare</strong> are not refunded.</p>
              </div>
              <div lang="kn">
                <p>ನಮ್ಮ BMTC ಆ್ಯಪ್ ಮೂಲಕ ಮಾಡಿದ ಪಾವತಿಯನ್ನು ಎಲ್ಲಾ BMTC ಕಂಡಕ್ಟರ್‌ಗಳು ಸ್ವೀಕರಿಸಬೇಕು. ಕಂಡಕ್ಟರ್ ನಿರಾಕರಿಸಿದರೆ, ಬಸ್ ಸಂಖ್ಯೆ, ಮಾರ್ಗ ಸಂಖ್ಯೆ, ದಿನಾಂಕ, ಸಮಯ ಮತ್ತು ಹತ್ತಿದ ನಿಲ್ದಾಣದ ವಿವರಗಳೊಂದಿಗೆ <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> ಗೆ ಬರೆಯಿರಿ ಅಥವಾ <a href="tel:08022483777"><strong>080-22483777</strong></a> ಗೆ ಕರೆ ಮಾಡಿ. ಕಂಡಕ್ಟರ್ ಹೆಸರು ಅಥವಾ ಬ್ಯಾಡ್ಜ್ ಸಂಖ್ಯೆ ಗಮನಿಸಿದ್ದರೆ, ಅದು BMTC ಗೆ ಬೇಗ ಕ್ರಮ ಕೈಗೊಳ್ಳಲು ಸಹಾಯವಾಗುತ್ತದೆ.</p>
                <p><strong>QuickPay</strong> ಮೂಲಕ ಪಾವತಿಸಿ ಮಾನ್ಯವಾಗದಿದ್ದರೆ, ಆ ಮೊತ್ತ ತಾನಾಗಿಯೇ ನಿಮ್ಮ ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂತಿರುಗುತ್ತದೆ. <strong>Find fare</strong> ಮೂಲಕ ಪಾವತಿಸಿದ ಮೊತ್ತ ಮರುಪಾವತಿಯಾಗುವುದಿಲ್ಲ.</p>
              </div>
            </div>
          </details>

          <details id="tickets-8">
            <summary>
              <span lang="en">Where can I see my tickets and receipts?</span>
              <span lang="kn">ನನ್ನ ಟಿಕೆಟ್‌ಗಳು ಮತ್ತು ರಸೀದಿಗಳನ್ನು ಎಲ್ಲಿ ನೋಡಬಹುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Open <strong>My Tickets</strong> from the bottom bar.</p>
                <ul>
                  <li><strong>Active</strong> shows tickets and passes you can use right now.</li>
                  <li><strong>History</strong> shows past rides and expired passes. Tap <strong>View Receipt</strong> on any ride to see the digital receipt with bus number, route, stops and fare.</li>
                </ul>
                <p>The app keeps the last 2 months of history. For older tickets, use <strong>Request history</strong> at the bottom of the History tab.</p>
              </div>
              <div lang="kn">
                <p>ಕೆಳಗಿನ ಪಟ್ಟಿಯಿಂದ <strong>My Tickets</strong> ತೆರೆಯಿರಿ.</p>
                <ul>
                  <li><strong>Active</strong> ನಲ್ಲಿ ಈಗ ಬಳಸಬಹುದಾದ ಟಿಕೆಟ್‌ಗಳು ಮತ್ತು ಪಾಸ್‌ಗಳು ಕಾಣಿಸುತ್ತವೆ.</li>
                  <li><strong>History</strong> ನಲ್ಲಿ ಹಿಂದಿನ ಪ್ರಯಾಣಗಳು ಮತ್ತು ಅವಧಿ ಮುಗಿದ ಪಾಸ್‌ಗಳು ಕಾಣಿಸುತ್ತವೆ. ಯಾವುದೇ ಪ್ರಯಾಣದ <strong>View Receipt</strong> ಒತ್ತಿದರೆ ಬಸ್ ಸಂಖ್ಯೆ, ಮಾರ್ಗ, ನಿಲ್ದಾಣಗಳು ಮತ್ತು ದರದೊಂದಿಗೆ ಡಿಜಿಟಲ್ ರಸೀದಿ ಕಾಣಿಸುತ್ತದೆ.</li>
                </ul>
                <p>ಆ್ಯಪ್ ಕೊನೆಯ 2 ತಿಂಗಳ ಇತಿಹಾಸವನ್ನು ತೋರಿಸುತ್ತದೆ. ಹಳೆಯ ಟಿಕೆಟ್‌ಗಳಿಗಾಗಿ History ಟ್ಯಾಬ್‌ನ ಕೆಳಭಾಗದಲ್ಲಿರುವ <strong>Request history</strong> ಬಳಸಿ.</p>
              </div>
            </div>
          </details>
        </section>

        {/* Section: Wallet */}
        <section id="wallet">
          <h2>
            <span lang="en">Mobile Wallet</span>
            <span lang="kn">ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್</span>
          </h2>
          <p className="blurb">
            <span lang="en">The prepaid balance inside the app that pays for tickets and passes</span>
            <span lang="kn">ಟಿಕೆಟ್ ಮತ್ತು ಪಾಸ್‌ಗಳಿಗೆ ಪಾವತಿಸುವ ಆ್ಯಪ್‌ನೊಳಗಿನ ಪ್ರೀಪೇಯ್ಡ್ ಬ್ಯಾಲೆನ್ಸ್</span>
          </p>

          <details id="wallet-1">
            <summary>
              <span lang="en">What is the Mobile Wallet?</span>
              <span lang="kn">ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್ ಎಂದರೇನು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>The Mobile Wallet is a prepaid balance built into the Namma BMTC app. You add money once and then pay for bus tickets and passes from it, without opening a UPI app or handling cash on the bus.</p>
                <p>Every account has a wallet from the moment you sign in with your mobile number. There is nothing to apply for, and no KYC is needed.</p>
              </div>
              <div lang="kn">
                <p>ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್ ಎಂದರೆ ನಮ್ಮ BMTC ಆ್ಯಪ್‌ನೊಳಗೇ ಇರುವ ಪ್ರೀಪೇಯ್ಡ್ ಬ್ಯಾಲೆನ್ಸ್. ಒಮ್ಮೆ ಹಣ ಸೇರಿಸಿದರೆ, ಬಸ್‌ನಲ್ಲಿ UPI ಆ್ಯಪ್ ತೆರೆಯದೆ ಅಥವಾ ನಗದು ಬಳಸದೆ ಟಿಕೆಟ್ ಮತ್ತು ಪಾಸ್‌ಗಳಿಗೆ ಅದರಿಂದ ಪಾವತಿಸಬಹುದು.</p>
                <p>ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯಿಂದ ಸೈನ್ ಇನ್ ಮಾಡಿದ ಕ್ಷಣದಿಂದಲೇ ಪ್ರತಿ ಖಾತೆಗೂ ವ್ಯಾಲೆಟ್ ಇರುತ್ತದೆ. ಅರ್ಜಿ ಸಲ್ಲಿಸುವ ಅಗತ್ಯವಿಲ್ಲ, KYC ಬೇಕಾಗಿಲ್ಲ.</p>
              </div>
            </div>
          </details>

          <details id="wallet-2">
            <summary>
              <span lang="en">How do I add money to the Mobile Wallet?</span>
              <span lang="kn">ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಣ ಹೇಗೆ ಸೇರಿಸುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Tap <strong>Recharge Wallet</strong> on the wallet screen, or the wallet icon at the top of the home screen.</p>
                <ul>
                  <li>Pick ₹20, ₹100 or ₹200, or enter your own amount.</li>
                  <li>Pay using any UPI app, net banking, or a debit or credit card.</li>
                </ul>
                <p>The recharge reflects in your balance immediately after the payment succeeds.</p>
              </div>
              <div lang="kn">
                <p>ವ್ಯಾಲೆಟ್ ಪರದೆಯಲ್ಲಿ <strong>Recharge Wallet</strong> ಒತ್ತಿ, ಅಥವಾ ಮುಖಪುಟದ ಮೇಲ್ಭಾಗದಲ್ಲಿರುವ ವ್ಯಾಲೆಟ್ ಐಕಾನ್ ಒತ್ತಿ.</p>
                <ul>
                  <li>₹20, ₹100 ಅಥವಾ ₹200 ಆಯ್ಕೆ ಮಾಡಿ, ಅಥವಾ ನಿಮಗೆ ಬೇಕಾದ ಮೊತ್ತ ನಮೂದಿಸಿ.</li>
                  <li>ಯಾವುದೇ UPI ಆ್ಯಪ್, ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್, ಅಥವಾ ಡೆಬಿಟ್/ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಬಳಸಿ ಪಾವತಿಸಿ.</li>
                </ul>
                <p>ಪಾವತಿ ಯಶಸ್ವಿಯಾದ ತಕ್ಷಣ ರೀಚಾರ್ಜ್ ನಿಮ್ಮ ಬ್ಯಾಲೆನ್ಸ್‌ನಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="wallet-3">
            <summary>
              <span lang="en">Where can I use the wallet balance?</span>
              <span lang="kn">ವ್ಯಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಎಲ್ಲಿ ಬಳಸಬಹುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>The balance can be used for:</p>
                <ul>
                  <li>Tickets on any BMTC bus, through <strong>QuickPay</strong></li>
                  <li>Daily, weekly and monthly bus passes bought in the app</li>
                </ul>
                <p>It cannot be used outside the Namma BMTC app.</p>
              </div>
              <div lang="kn">
                <p>ಬ್ಯಾಲೆನ್ಸ್ ಅನ್ನು ಇವುಗಳಿಗೆ ಬಳಸಬಹುದು:</p>
                <ul>
                  <li><strong>QuickPay</strong> ಮೂಲಕ ಯಾವುದೇ BMTC ಬಸ್‌ನ ಟಿಕೆಟ್</li>
                  <li>ಆ್ಯಪ್‌ನಲ್ಲಿ ಖರೀದಿಸುವ ದೈನಿಕ, ವಾರದ ಮತ್ತು ಮಾಸಿಕ ಬಸ್ ಪಾಸ್‌ಗಳು</li>
                </ul>
                <p>ನಮ್ಮ BMTC ಆ್ಯಪ್‌ನ ಹೊರಗೆ ಇದನ್ನು ಬಳಸಲು ಸಾಧ್ಯವಿಲ್ಲ.</p>
              </div>
            </div>
          </details>

          <details id="wallet-4">
            <summary>
              <span lang="en">When is money deducted from the wallet?</span>
              <span lang="kn">ವ್ಯಾಲೆಟ್‌ನಿಂದ ಹಣ ಯಾವಾಗ ಕಡಿತವಾಗುತ್ತದೆ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>For a ticket bought via <strong>QuickPay</strong>, the amount is deducted when you tap <strong>Confirm payment</strong>. If the conductor is unable to validate it, the amount is returned to your Mobile Wallet within 24 hours.</p>
                <p>For a ticket bought via <strong>Find fare</strong>, or for a pass, the amount is deducted when you complete the purchase, and it is not refundable.</p>
              </div>
              <div lang="kn">
                <p><strong>QuickPay</strong> ಮೂಲಕ ಖರೀದಿಸಿದ ಟಿಕೆಟ್‌ಗೆ, ನೀವು <strong>Confirm payment</strong> ಒತ್ತಿದಾಗ ಮೊತ್ತ ಕಡಿತವಾಗುತ್ತದೆ. ಕಂಡಕ್ಟರ್ ಮಾನ್ಯ ಮಾಡಲು ಸಾಧ್ಯವಾಗದಿದ್ದರೆ, ಮೊತ್ತವು 24 ಗಂಟೆಗಳೊಳಗೆ ನಿಮ್ಮ ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂತಿರುಗುತ್ತದೆ.</p>
                <p><strong>Find fare</strong> ಮೂಲಕ ಖರೀದಿಸಿದ ಟಿಕೆಟ್‌ಗೆ ಅಥವಾ ಪಾಸ್‌ಗೆ, ಖರೀದಿ ಪೂರ್ಣಗೊಳಿಸಿದಾಗ ಮೊತ್ತ ಕಡಿತವಾಗುತ್ತದೆ, ಮತ್ತು ಅದು ಮರುಪಾವತಿಯಾಗುವುದಿಲ್ಲ.</p>
              </div>
            </div>
          </details>

          <details id="wallet-5">
            <summary>
              <span lang="en">How can I see my wallet balance and transaction history?</span>
              <span lang="kn">ನನ್ನ ವ್ಯಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಮತ್ತು ವಹಿವಾಟು ಇತಿಹಾಸವನ್ನು ಹೇಗೆ ನೋಡುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Open the wallet from the home screen or from <strong>Account → Mobile Wallet</strong>. Your balance is shown at the top, and <strong>My Transactions</strong> lists every recharge and payment with its status:</p>
                <ul>
                  <li><strong>Money added</strong>: a recharge</li>
                  <li><strong>In Process</strong>: a ticket payment waiting for the conductor's confirmation</li>
                  <li><strong>Completed</strong>: a ticket was issued</li>
                  <li><strong>Returned</strong>: the amount came back to your wallet</li>
                </ul>
                <p>The last 2 months are shown in the app. For older transactions, raise a request from the app and the statement is sent to your email.</p>
              </div>
              <div lang="kn">
                <p>ಮುಖಪುಟದಿಂದ ಅಥವಾ <strong>Account → Mobile Wallet</strong> ನಿಂದ ವ್ಯಾಲೆಟ್ ತೆರೆಯಿರಿ. ಮೇಲ್ಭಾಗದಲ್ಲಿ ನಿಮ್ಮ ಬ್ಯಾಲೆನ್ಸ್ ಕಾಣಿಸುತ್ತದೆ, ಮತ್ತು <strong>My Transactions</strong> ನಲ್ಲಿ ಪ್ರತಿ ರೀಚಾರ್ಜ್ ಮತ್ತು ಪಾವತಿ ಅದರ ಸ್ಥಿತಿಯೊಂದಿಗೆ ಕಾಣಿಸುತ್ತದೆ:</p>
                <ul>
                  <li><strong>Money added</strong>: ರೀಚಾರ್ಜ್</li>
                  <li><strong>In Process</strong>: ಕಂಡಕ್ಟರ್ ದೃಢೀಕರಣಕ್ಕಾಗಿ ಕಾಯುತ್ತಿರುವ ಟಿಕೆಟ್ ಪಾವತಿ</li>
                  <li><strong>Completed</strong>: ಟಿಕೆಟ್ ನೀಡಲಾಗಿದೆ</li>
                  <li><strong>Returned</strong>: ಮೊತ್ತ ನಿಮ್ಮ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂತಿರುಗಿದೆ</li>
                </ul>
                <p>ಕೊನೆಯ 2 ತಿಂಗಳ ವಹಿವಾಟುಗಳು ಆ್ಯಪ್‌ನಲ್ಲಿ ಕಾಣಿಸುತ್ತವೆ. ಹಳೆಯ ವಹಿವಾಟುಗಳಿಗಾಗಿ ಆ್ಯಪ್‌ನಿಂದ ವಿನಂತಿ ಸಲ್ಲಿಸಿದರೆ, ವಿವರಣೆ ನಿಮ್ಮ ಇಮೇಲ್‌ಗೆ ಕಳುಹಿಸಲಾಗುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="wallet-6">
            <summary>
              <span lang="en">Is there a limit on how much I can add or spend?</span>
              <span lang="kn">ಎಷ್ಟು ಹಣ ಸೇರಿಸಬಹುದು ಅಥವಾ ಖರ್ಚು ಮಾಡಬಹುದು ಎಂಬುದಕ್ಕೆ ಮಿತಿ ಇದೆಯೇ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Yes. These limits follow Reserve Bank of India rules for prepaid wallets that do not need KYC.</p>
                <ul>
                  <li>Maximum balance at any time: ₹3,000</li>
                  <li>Maximum recharge in a month: ₹10,000</li>
                  <li>Maximum spend in a month: ₹10,000</li>
                  <li>Maximum recharge in a financial year: ₹1,20,000</li>
                </ul>
              </div>
              <div lang="kn">
                <p>ಹೌದು. KYC ಅಗತ್ಯವಿಲ್ಲದ ಪ್ರೀಪೇಯ್ಡ್ ವ್ಯಾಲೆಟ್‌ಗಳಿಗೆ ಭಾರತೀಯ ರಿಸರ್ವ್ ಬ್ಯಾಂಕ್ ನಿಯಮಗಳ ಪ್ರಕಾರ ಈ ಮಿತಿಗಳಿವೆ.</p>
                <ul>
                  <li>ಯಾವುದೇ ಸಮಯದಲ್ಲಿ ಗರಿಷ್ಠ ಬ್ಯಾಲೆನ್ಸ್: ₹3,000</li>
                  <li>ತಿಂಗಳಿಗೆ ಗರಿಷ್ಠ ರೀಚಾರ್ಜ್: ₹10,000</li>
                  <li>ತಿಂಗಳಿಗೆ ಗರಿಷ್ಠ ಖರ್ಚು: ₹10,000</li>
                  <li>ಆರ್ಥಿಕ ವರ್ಷದಲ್ಲಿ ಗರಿಷ್ಠ ರೀಚಾರ್ಜ್: ₹1,20,000</li>
                </ul>
              </div>
            </div>
          </details>

          <details id="wallet-7">
            <summary>
              <span lang="en">Can I transfer the wallet balance back to my bank account?</span>
              <span lang="kn">ವ್ಯಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಅನ್ನು ನನ್ನ ಬ್ಯಾಂಕ್ ಖಾತೆಗೆ ಹಿಂತಿರುಗಿಸಬಹುದೇ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>No. Money added to the Mobile Wallet cannot be withdrawn or transferred to a bank account, UPI or any other wallet. It can only be used for tickets and passes in the Namma BMTC app. Please add only what you expect to use.</p>
              </div>
              <div lang="kn">
                <p>ಇಲ್ಲ. ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಸೇರಿಸಿದ ಹಣವನ್ನು ಬ್ಯಾಂಕ್ ಖಾತೆ, UPI ಅಥವಾ ಇನ್ನಾವುದೇ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂಪಡೆಯಲು ಅಥವಾ ವರ್ಗಾಯಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ. ಇದನ್ನು ನಮ್ಮ BMTC ಆ್ಯಪ್‌ನಲ್ಲಿ ಟಿಕೆಟ್ ಮತ್ತು ಪಾಸ್‌ಗಳಿಗೆ ಮಾತ್ರ ಬಳಸಬಹುದು. ನೀವು ಬಳಸುವಷ್ಟು ಮಾತ್ರ ಸೇರಿಸಿ.</p>
              </div>
            </div>
          </details>

          <details id="wallet-8">
            <summary>
              <span lang="en">I got a new phone. Will my wallet balance move with me?</span>
              <span lang="kn">ನಾನು ಹೊಸ ಫೋನ್ ತೆಗೆದುಕೊಂಡಿದ್ದೇನೆ. ನನ್ನ ವ್ಯಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್ ಹೊಸ ಫೋನ್‌ಗೆ ಬರುತ್ತದೆಯೇ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Yes. Your wallet is linked to your mobile number, not to the phone. Sign in on the new phone with the same number and request the wallet transfer from the app. For your safety the wallet is active on only one device at a time, and the transfer can take up to 24 hours.</p>
                <p>If your phone is lost, sign in on another phone with the same number, or call <a href="tel:08022483777"><strong>080-22483777</strong></a> and ask for the wallet to be blocked.</p>
              </div>
              <div lang="kn">
                <p>ಹೌದು. ನಿಮ್ಮ ವ್ಯಾಲೆಟ್ ಫೋನ್‌ಗೆ ಅಲ್ಲ, ನಿಮ್ಮ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಗೆ ಜೋಡಿಸಲಾಗಿದೆ. ಹೊಸ ಫೋನ್‌ನಲ್ಲಿ ಅದೇ ಸಂಖ್ಯೆಯಿಂದ ಸೈನ್ ಇನ್ ಮಾಡಿ, ಆ್ಯಪ್‌ನಿಂದ ವ್ಯಾಲೆಟ್ ವರ್ಗಾವಣೆಗೆ ವಿನಂತಿಸಿ. ನಿಮ್ಮ ಸುರಕ್ಷತೆಗಾಗಿ ವ್ಯಾಲೆಟ್ ಒಂದು ಸಮಯದಲ್ಲಿ ಒಂದೇ ಸಾಧನದಲ್ಲಿ ಸಕ್ರಿಯವಾಗಿರುತ್ತದೆ, ಮತ್ತು ವರ್ಗಾವಣೆಗೆ 24 ಗಂಟೆಗಳವರೆಗೆ ಸಮಯ ಹಿಡಿಯಬಹುದು.</p>
                <p>ಫೋನ್ ಕಳೆದುಹೋದರೆ, ಅದೇ ಸಂಖ್ಯೆಯಿಂದ ಬೇರೆ ಫೋನ್‌ನಲ್ಲಿ ಸೈನ್ ಇನ್ ಮಾಡಿ, ಅಥವಾ <a href="tel:08022483777"><strong>080-22483777</strong></a> ಗೆ ಕರೆ ಮಾಡಿ ವ್ಯಾಲೆಟ್ ಬ್ಲಾಕ್ ಮಾಡಲು ಕೇಳಿ.</p>
              </div>
            </div>
          </details>
        </section>

        {/* Section: Passes */}
        <section id="passes">
          <h2>
            <span lang="en">Bus Passes</span>
            <span lang="kn">ಬಸ್ ಪಾಸ್‌ಗಳು</span>
          </h2>
          <p className="blurb">
            <span lang="en">Buying and using daily, weekly and monthly passes in the app</span>
            <span lang="kn">ಆ್ಯಪ್‌ನಲ್ಲಿ ದೈನಿಕ, ವಾರದ ಮತ್ತು ಮಾಸಿಕ ಪಾಸ್‌ಗಳನ್ನು ಖರೀದಿಸುವುದು ಮತ್ತು ಬಳಸುವುದು</span>
          </p>

          <details id="passes-1">
            <summary>
              <span lang="en">Which passes can I buy in the app?</span>
              <span lang="kn">ಆ್ಯಪ್‌ನಲ್ಲಿ ಯಾವ ಪಾಸ್‌ಗಳನ್ನು ಖರೀದಿಸಬಹುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Tap <strong>Buy Pass</strong> on the home screen to see the passes available for each BMTC service, such as Ordinary, Vajra and Vayu Vajra. Each service offers daily, weekly or monthly plans. Prices and the buses each pass is valid on are shown in the app before you pay.</p>
              </div>
              <div lang="kn">
                <p>ಮುಖಪುಟದಲ್ಲಿ <strong>Buy Pass</strong> ಒತ್ತಿದರೆ, ಸಾಮಾನ್ಯ, ವಜ್ರ ಮತ್ತು ವಾಯು ವಜ್ರ ಮುಂತಾದ ಪ್ರತಿ BMTC ಸೇವೆಗೆ ಲಭ್ಯವಿರುವ ಪಾಸ್‌ಗಳು ಕಾಣಿಸುತ್ತವೆ. ಪ್ರತಿ ಸೇವೆಗೆ ದೈನಿಕ, ವಾರದ ಅಥವಾ ಮಾಸಿಕ ಯೋಜನೆಗಳಿವೆ. ಪಾವತಿಗೆ ಮೊದಲು ಬೆಲೆಗಳು ಮತ್ತು ಪಾಸ್ ಯಾವ ಬಸ್‌ಗಳಲ್ಲಿ ಮಾನ್ಯ ಎಂಬುದನ್ನು ಆ್ಯಪ್ ತೋರಿಸುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="passes-2">
            <summary>
              <span lang="en">How do I buy a pass?</span>
              <span lang="kn">ಪಾಸ್ ಹೇಗೆ ಖರೀದಿಸುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <ul>
                  <li>Tap <strong>Buy Pass</strong>, choose the service and then the plan.</li>
                  <li>Enter your name, gender and date of birth exactly as on your government photo ID, and choose the pass start date.</li>
                  <li>Upload a clear selfie.</li>
                  <li>Check the pass details, validity and terms, then tap <strong>Make Payment</strong>.</li>
                  <li>Pay from your Mobile Wallet, or with UPI, net banking or a card.</li>
                </ul>
                <p>The pass appears under <strong>My Tickets → Active</strong> as soon as payment succeeds.</p>
              </div>
              <div lang="kn">
                <ul>
                  <li><strong>Buy Pass</strong> ಒತ್ತಿ, ಸೇವೆ ಮತ್ತು ನಂತರ ಯೋಜನೆ ಆಯ್ಕೆ ಮಾಡಿ.</li>
                  <li>ನಿಮ್ಮ ಸರ್ಕಾರಿ ಫೋಟೋ ಗುರುತಿನ ಚೀಟಿಯಲ್ಲಿರುವಂತೆಯೇ ಹೆಸರು, ಲಿಂಗ ಮತ್ತು ಜನ್ಮ ದಿನಾಂಕ ನಮೂದಿಸಿ, ಪಾಸ್ ಪ್ರಾರಂಭ ದಿನಾಂಕ ಆಯ್ಕೆ ಮಾಡಿ.</li>
                  <li>ಸ್ಪಷ್ಟವಾದ ಸೆಲ್ಫಿ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ.</li>
                  <li>ಪಾಸ್ ವಿವರಗಳು, ಮಾನ್ಯತೆ ಮತ್ತು ನಿಯಮಗಳನ್ನು ಪರಿಶೀಲಿಸಿ, <strong>Make Payment</strong> ಒತ್ತಿ.</li>
                  <li>ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್, UPI, ನೆಟ್ ಬ್ಯಾಂಕಿಂಗ್ ಅಥವಾ ಕಾರ್ಡ್ ಮೂಲಕ ಪಾವತಿಸಿ.</li>
                </ul>
                <p>ಪಾವತಿ ಯಶಸ್ವಿಯಾದ ತಕ್ಷಣ ಪಾಸ್ <strong>My Tickets → Active</strong> ನಲ್ಲಿ ಕಾಣಿಸುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="passes-3">
            <summary>
              <span lang="en">Why do I need to upload a photo and my details?</span>
              <span lang="kn">ನಾನು ಫೋಟೋ ಮತ್ತು ವಿವರಗಳನ್ನು ಏಕೆ ನೀಡಬೇಕು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Your photo and name are printed on the digital pass, and the conductor may compare them with you or your ID during the journey. This stops passes from being shared. The details are stored securely and are not shared with anyone else.</p>
              </div>
              <div lang="kn">
                <p>ನಿಮ್ಮ ಫೋಟೋ ಮತ್ತು ಹೆಸರು ಡಿಜಿಟಲ್ ಪಾಸ್‌ನಲ್ಲಿ ಮುದ್ರಿತವಾಗುತ್ತವೆ, ಮತ್ತು ಪ್ರಯಾಣದ ವೇಳೆ ಕಂಡಕ್ಟರ್ ಅವುಗಳನ್ನು ನಿಮ್ಮೊಂದಿಗೆ ಅಥವಾ ನಿಮ್ಮ ಗುರುತಿನ ಚೀಟಿಯೊಂದಿಗೆ ಹೋಲಿಸಬಹುದು. ಇದರಿಂದ ಪಾಸ್ ಹಂಚಿಕೊಳ್ಳುವುದನ್ನು ತಡೆಯಲಾಗುತ್ತದೆ. ವಿವರಗಳನ್ನು ಸುರಕ್ಷಿತವಾಗಿ ಸಂಗ್ರಹಿಸಲಾಗುತ್ತದೆ ಮತ್ತು ಬೇರೆ ಯಾರೊಂದಿಗೂ ಹಂಚಿಕೊಳ್ಳುವುದಿಲ್ಲ.</p>
              </div>
            </div>
          </details>

          <details id="passes-4">
            <summary>
              <span lang="en">How do I use my pass on the bus?</span>
              <span lang="kn">ಬಸ್‌ನಲ್ಲಿ ನನ್ನ ಪಾಸ್ ಹೇಗೆ ಬಳಸುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>After boarding, open <strong>My Tickets → Active</strong>, and tap <strong>Use Now</strong> on your pass. Confirm with <strong>Validate now</strong>. The pass is now active for 15 minutes: show it to the conductor, who validates it on the ticket machine and a ticket for that ride is generated.</p>
                <p>Validate once per ride, after you board. There is no need to validate in advance.</p>
              </div>
              <div lang="kn">
                <p>ಬಸ್ ಹತ್ತಿದ ನಂತರ <strong>My Tickets → Active</strong> ತೆರೆದು, ನಿಮ್ಮ ಪಾಸ್‌ನ <strong>Use Now</strong> ಒತ್ತಿ. <strong>Validate now</strong> ಒತ್ತಿ ದೃಢೀಕರಿಸಿ. ಈಗ ಪಾಸ್ 15 ನಿಮಿಷ ಸಕ್ರಿಯವಾಗಿರುತ್ತದೆ: ಇದನ್ನು ಕಂಡಕ್ಟರ್‌ಗೆ ತೋರಿಸಿ. ಅವರು ಟಿಕೆಟ್ ಯಂತ್ರದಲ್ಲಿ ಮಾನ್ಯ ಮಾಡಿದಾಗ ಆ ಪ್ರಯಾಣಕ್ಕೆ ಟಿಕೆಟ್ ರಚನೆಯಾಗುತ್ತದೆ.</p>
                <p>ಪ್ರತಿ ಪ್ರಯಾಣಕ್ಕೆ ಒಮ್ಮೆ, ಬಸ್ ಹತ್ತಿದ ನಂತರ ಮಾನ್ಯ ಮಾಡಿ. ಮುಂಚಿತವಾಗಿ ಮಾನ್ಯ ಮಾಡುವ ಅಗತ್ಯವಿಲ್ಲ.</p>
              </div>
            </div>
          </details>

          <details id="passes-5">
            <summary>
              <span lang="en">Can I buy a pass today and start it on a later date?</span>
              <span lang="kn">ಇಂದು ಪಾಸ್ ಖರೀದಿಸಿ ಬೇರೆ ದಿನಾಂಕದಿಂದ ಪ್ರಾರಂಭಿಸಬಹುದೇ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>Yes. While entering your details, choose the <strong>Pass Start Date</strong>. The pass becomes valid from that date. A daily pass is valid for the calendar day, from 12:01 AM to 11:59 PM.</p>
              </div>
              <div lang="kn">
                <p>ಹೌದು. ವಿವರಗಳನ್ನು ನಮೂದಿಸುವಾಗ <strong>Pass Start Date</strong> ಆಯ್ಕೆ ಮಾಡಿ. ಆ ದಿನಾಂಕದಿಂದ ಪಾಸ್ ಮಾನ್ಯವಾಗುತ್ತದೆ. ದೈನಿಕ ಪಾಸ್ ಆ ದಿನದ ಬೆಳಿಗ್ಗೆ 12:01 ರಿಂದ ರಾತ್ರಿ 11:59 ರವರೆಗೆ ಮಾನ್ಯವಾಗಿರುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="passes-6">
            <summary>
              <span lang="en">My pass is about to expire. How do I renew it?</span>
              <span lang="kn">ನನ್ನ ಪಾಸ್ ಅವಧಿ ಮುಗಿಯಲಿದೆ. ಹೇಗೆ ನವೀಕರಿಸುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>When a pass is close to expiry, the Active tab shows <strong>Pass expiring soon</strong> with a <strong>Renew</strong> link. Tap it to buy the same pass again. Expired passes move to the History tab.</p>
              </div>
              <div lang="kn">
                <p>ಪಾಸ್ ಅವಧಿ ಮುಗಿಯುವ ಹತ್ತಿರ ಬಂದಾಗ, Active ಟ್ಯಾಬ್‌ನಲ್ಲಿ <strong>Pass expiring soon</strong> ಮತ್ತು <strong>Renew</strong> ಲಿಂಕ್ ಕಾಣಿಸುತ್ತದೆ. ಅದೇ ಪಾಸ್ ಮತ್ತೆ ಖರೀದಿಸಲು ಅದನ್ನು ಒತ್ತಿ. ಅವಧಿ ಮುಗಿದ ಪಾಸ್‌ಗಳು History ಟ್ಯಾಬ್‌ಗೆ ಹೋಗುತ್ತವೆ.</p>
              </div>
            </div>
          </details>

          <details id="passes-7">
            <summary>
              <span lang="en">The conductor did not accept my pass.</span>
              <span lang="kn">ಕಂಡಕ್ಟರ್ ನನ್ನ ಪಾಸ್ ಸ್ವೀಕರಿಸಲಿಲ್ಲ.</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>First check that the pass is valid on that bus: each pass covers specific services, shown in the pass terms. If the pass was valid and validated, and the conductor still refused it, report it to <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> or <a href="tel:08022483777"><strong>080-22483777</strong></a> with the bus number, route number, date, time and boarding stop.</p>
              </div>
              <div lang="kn">
                <p>ಮೊದಲು ಆ ಬಸ್‌ನಲ್ಲಿ ಪಾಸ್ ಮಾನ್ಯವೇ ಎಂದು ಪರಿಶೀಲಿಸಿ: ಪ್ರತಿ ಪಾಸ್ ನಿರ್ದಿಷ್ಟ ಸೇವೆಗಳಿಗೆ ಮಾತ್ರ ಅನ್ವಯಿಸುತ್ತದೆ, ಇದು ಪಾಸ್ ನಿಯಮಗಳಲ್ಲಿ ಇರುತ್ತದೆ. ಪಾಸ್ ಮಾನ್ಯವಾಗಿದ್ದು, ಮಾನ್ಯ ಮಾಡಿದ್ದರೂ ಕಂಡಕ್ಟರ್ ನಿರಾಕರಿಸಿದರೆ, ಬಸ್ ಸಂಖ್ಯೆ, ಮಾರ್ಗ ಸಂಖ್ಯೆ, ದಿನಾಂಕ, ಸಮಯ ಮತ್ತು ಹತ್ತಿದ ನಿಲ್ದಾಣದ ವಿವರಗಳೊಂದಿಗೆ <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> ಅಥವಾ <a href="tel:08022483777"><strong>080-22483777</strong></a> ಗೆ ದೂರು ನೀಡಿ.</p>
              </div>
            </div>
          </details>

          <details id="passes-8">
            <summary>
              <span lang="en">Can I cancel a pass or transfer it to someone else?</span>
              <span lang="kn">ಪಾಸ್ ರದ್ದು ಮಾಡಬಹುದೇ ಅಥವಾ ಬೇರೆಯವರಿಗೆ ವರ್ಗಾಯಿಸಬಹುದೇ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>No. A pass is issued in your name with your photo and cannot be transferred. Once purchased, a pass cannot be cancelled or refunded, so please check the service, plan and start date before you pay.</p>
              </div>
              <div lang="kn">
                <p>ಇಲ್ಲ. ಪಾಸ್ ನಿಮ್ಮ ಹೆಸರು ಮತ್ತು ಫೋಟೋದೊಂದಿಗೆ ನೀಡಲಾಗುತ್ತದೆ, ಆದ್ದರಿಂದ ವರ್ಗಾಯಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ. ಒಮ್ಮೆ ಖರೀದಿಸಿದ ಪಾಸ್ ಅನ್ನು ರದ್ದು ಮಾಡಲು ಅಥವಾ ಮರುಪಾವತಿ ಪಡೆಯಲು ಸಾಧ್ಯವಿಲ್ಲ. ಆದ್ದರಿಂದ ಪಾವತಿಗೆ ಮೊದಲು ಸೇವೆ, ಯೋಜನೆ ಮತ್ತು ಪ್ರಾರಂಭ ದಿನಾಂಕವನ್ನು ಪರಿಶೀಲಿಸಿ.</p>
              </div>
            </div>
          </details>
        </section>

        {/* Section: Payments */}
        <section id="payments">
          <h2>
            <span lang="en">Payment Issues and Refunds</span>
            <span lang="kn">ಪಾವತಿ ಸಮಸ್ಯೆಗಳು ಮತ್ತು ಮರುಪಾವತಿ</span>
          </h2>
          <p className="blurb">
            <span lang="en">What to do when a payment fails, money is deducted, or a refund is late</span>
            <span lang="kn">ಪಾವತಿ ವಿಫಲವಾದಾಗ, ಹಣ ಕಡಿತವಾದಾಗ ಅಥವಾ ಮರುಪಾವತಿ ತಡವಾದಾಗ ಏನು ಮಾಡಬೇಕು</span>
          </p>

          <details id="payments-1">
            <summary>
              <span lang="en">I paid for a ticket or pass but it is not showing in the app.</span>
              <span lang="kn">ನಾನು ಟಿಕೆಟ್ ಅಥವಾ ಪಾಸ್‌ಗೆ ಪಾವತಿಸಿದೆ, ಆದರೆ ಅದು ಆ್ಯಪ್‌ನಲ್ಲಿ ಕಾಣಿಸುತ್ತಿಲ್ಲ.</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>One of two things has happened.</p>
                <ul>
                  <li><strong>The payment did not go through.</strong> The bank or UPI app may show it as debited, but the payment gateway has not confirmed it. The amount is reversed to the account you paid from, usually within 7 working days.</li>
                  <li><strong>The payment went through but the app has not updated.</strong> Check your internet connection, open <strong>My Tickets</strong> again and pull down to refresh.</li>
                </ul>
                <p>If the ticket or pass is still missing after a few minutes, write to <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> with the transaction ID or UPI reference number, the amount, and the date and time.</p>
              </div>
              <div lang="kn">
                <p>ಎರಡರಲ್ಲಿ ಒಂದು ಆಗಿರಬಹುದು.</p>
                <ul>
                  <li><strong>ಪಾವತಿ ಪೂರ್ಣಗೊಂಡಿಲ್ಲ.</strong> ಬ್ಯಾಂಕ್ ಅಥವಾ UPI ಆ್ಯಪ್ ಹಣ ಕಡಿತವಾಗಿದೆ ಎಂದು ತೋರಿಸಿದರೂ, ಪಾವತಿ ಗೇಟ್‌ವೇ ಅದನ್ನು ದೃಢೀಕರಿಸಿಲ್ಲ. ಮೊತ್ತವು ಸಾಮಾನ್ಯವಾಗಿ 7 ಕೆಲಸದ ದಿನಗಳೊಳಗೆ ನೀವು ಪಾವತಿಸಿದ ಖಾತೆಗೆ ಹಿಂತಿರುಗುತ್ತದೆ.</li>
                  <li><strong>ಪಾವತಿ ಪೂರ್ಣಗೊಂಡಿದೆ, ಆದರೆ ಆ್ಯಪ್ ನವೀಕರಣವಾಗಿಲ್ಲ.</strong> ಇಂಟರ್ನೆಟ್ ಸಂಪರ್ಕ ಪರಿಶೀಲಿಸಿ, <strong>My Tickets</strong> ಮತ್ತೆ ತೆರೆದು ಕೆಳಗೆ ಎಳೆದು ರಿಫ್ರೆಶ್ ಮಾಡಿ.</li>
                </ul>
                <p>ಕೆಲವು ನಿಮಿಷಗಳ ನಂತರವೂ ಟಿಕೆಟ್ ಅಥವಾ ಪಾಸ್ ಕಾಣಿಸದಿದ್ದರೆ, ವಹಿವಾಟು ID ಅಥವಾ UPI ರೆಫರೆನ್ಸ್ ಸಂಖ್ಯೆ, ಮೊತ್ತ, ದಿನಾಂಕ ಮತ್ತು ಸಮಯದೊಂದಿಗೆ <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> ಗೆ ಬರೆಯಿರಿ.</p>
              </div>
            </div>
          </details>

          <details id="payments-2">
            <summary>
              <span lang="en">My wallet recharge failed but money was deducted from my bank.</span>
              <span lang="kn">ವ್ಯಾಲೆಟ್ ರೀಚಾರ್ಜ್ ವಿಫಲವಾಯಿತು, ಆದರೆ ಬ್ಯಾಂಕ್‌ನಿಂದ ಹಣ ಕಡಿತವಾಗಿದೆ.</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>If the recharge failed, the amount is not added to your wallet and the bank reverses the debit on its own, usually within 7 working days. You do not need to do anything.</p>
                <p>If the amount has not been reversed after 7 working days, write to <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> with the transaction ID or UPI reference number, the amount, and the date and time.</p>
              </div>
              <div lang="kn">
                <p>ರೀಚಾರ್ಜ್ ವಿಫಲವಾದರೆ, ಮೊತ್ತವು ವ್ಯಾಲೆಟ್‌ಗೆ ಸೇರುವುದಿಲ್ಲ ಮತ್ತು ಬ್ಯಾಂಕ್ ತಾನಾಗಿಯೇ, ಸಾಮಾನ್ಯವಾಗಿ 7 ಕೆಲಸದ ದಿನಗಳೊಳಗೆ ಕಡಿತವನ್ನು ಹಿಂತಿರುಗಿಸುತ್ತದೆ. ನೀವು ಏನೂ ಮಾಡಬೇಕಾಗಿಲ್ಲ.</p>
                <p>7 ಕೆಲಸದ ದಿನಗಳ ನಂತರವೂ ಮೊತ್ತ ಹಿಂತಿರುಗದಿದ್ದರೆ, ವಹಿವಾಟು ID ಅಥವಾ UPI ರೆಫರೆನ್ಸ್ ಸಂಖ್ಯೆ, ಮೊತ್ತ, ದಿನಾಂಕ ಮತ್ತು ಸಮಯದೊಂದಿಗೆ <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> ಗೆ ಬರೆಯಿರಿ.</p>
              </div>
            </div>
          </details>

          <details id="payments-3">
            <summary>
              <span lang="en">How long do refunds take?</span>
              <span lang="kn">ಮರುಪಾವತಿಗೆ ಎಷ್ಟು ಸಮಯ ಹಿಡಿಯುತ್ತದೆ?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <ul>
                  <li><strong>Ticket payment not validated by the conductor:</strong> returned to your Mobile Wallet automatically, within 24 hours.</li>
                  <li><strong>Failed recharge or failed online payment:</strong> reversed by the bank to the account you paid from, usually within 7 working days.</li>
                </ul>
                <p>Refunds are always made to the source: wallet payments go back to the wallet, and bank or UPI payments go back to the bank.</p>
              </div>
              <div lang="kn">
                <ul>
                  <li><strong>ಕಂಡಕ್ಟರ್ ಮಾನ್ಯ ಮಾಡದ ಟಿಕೆಟ್ ಪಾವತಿ:</strong> 24 ಗಂಟೆಗಳೊಳಗೆ ತಾನಾಗಿಯೇ ನಿಮ್ಮ ಮೊಬೈಲ್ ವ್ಯಾಲೆಟ್‌ಗೆ ಹಿಂತಿರುಗುತ್ತದೆ.</li>
                  <li><strong>ವಿಫಲವಾದ ರೀಚಾರ್ಜ್ ಅಥವಾ ಆನ್‌ಲೈನ್ ಪಾವತಿ:</strong> ಸಾಮಾನ್ಯವಾಗಿ 7 ಕೆಲಸದ ದಿನಗಳೊಳಗೆ ಬ್ಯಾಂಕ್ ನೀವು ಪಾವತಿಸಿದ ಖಾತೆಗೆ ಹಿಂತಿರುಗಿಸುತ್ತದೆ.</li>
                </ul>
                <p>ಮರುಪಾವತಿ ಯಾವಾಗಲೂ ಮೂಲಕ್ಕೇ ಆಗುತ್ತದೆ: ವ್ಯಾಲೆಟ್ ಪಾವತಿಗಳು ವ್ಯಾಲೆಟ್‌ಗೆ, ಬ್ಯಾಂಕ್ ಅಥವಾ UPI ಪಾವತಿಗಳು ಬ್ಯಾಂಕ್‌ಗೆ.</p>
              </div>
            </div>
          </details>

          <details id="payments-4">
            <summary>
              <span lang="en">I still have not received the refund that was promised.</span>
              <span lang="kn">ನನಗೆ ಭರವಸೆ ನೀಡಿದ ಮರುಪಾವತಿ ಇನ್ನೂ ಬಂದಿಲ್ಲ.</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <p>If it has been more than 7 working days, write to <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> with the details you shared earlier and the date of your first complaint, or call <a href="tel:08022483777"><strong>080-22483777</strong></a>. BMTC will take it up on priority.</p>
              </div>
              <div lang="kn">
                <p>7 ಕೆಲಸದ ದಿನಗಳಿಗಿಂತ ಹೆಚ್ಚು ಸಮಯವಾಗಿದ್ದರೆ, ನೀವು ಮೊದಲು ಹಂಚಿಕೊಂಡ ವಿವರಗಳು ಮತ್ತು ಮೊದಲ ದೂರಿನ ದಿನಾಂಕದೊಂದಿಗೆ <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a> ಗೆ ಬರೆಯಿರಿ, ಅಥವಾ <a href="tel:08022483777"><strong>080-22483777</strong></a> ಗೆ ಕರೆ ಮಾಡಿ. BMTC ಇದನ್ನು ಆದ್ಯತೆಯ ಮೇಲೆ ಪರಿಹರಿಸುತ್ತದೆ.</p>
              </div>
            </div>
          </details>

          <details id="payments-5">
            <summary>
              <span lang="en">How do I contact BMTC about the app?</span>
              <span lang="kn">ಆ್ಯಪ್ ಬಗ್ಗೆ BMTC ಅನ್ನು ಹೇಗೆ ಸಂಪರ್ಕಿಸುವುದು?</span>
            </summary>
            <div className="answer">
              <div lang="en">
                <ul>
                  <li>Email: <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a></li>
                  <li>Helpline: <a href="tel:08022483777"><strong>080-22483777</strong></a></li>
                </ul>
                <p>To help BMTC resolve your issue quickly, include your registered mobile number, the bus and route number, the date and time, and a screenshot of the ticket, pass or transaction.</p>
              </div>
              <div lang="kn">
                <ul>
                  <li>ಇಮೇಲ್: <a href="mailto:complaints@mybmtc.com"><strong>complaints@mybmtc.com</strong></a></li>
                  <li>ಸಹಾಯವಾಣಿ: <a href="tel:08022483777"><strong>080-22483777</strong></a></li>
                </ul>
                <p>BMTC ನಿಮ್ಮ ಸಮಸ್ಯೆಯನ್ನು ಬೇಗ ಪರಿಹರಿಸಲು, ನಿಮ್ಮ ನೋಂದಾಯಿತ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ, ಬಸ್ ಮತ್ತು ಮಾರ್ಗ ಸಂಖ್ಯೆ, ದಿನಾಂಕ ಮತ್ತು ಸಮಯ, ಹಾಗೂ ಟಿಕೆಟ್, ಪಾಸ್ ಅಥವಾ ವಹಿವಾಟಿನ ಸ್ಕ್ರೀನ್‌ಶಾಟ್ ಸೇರಿಸಿ.</p>
              </div>
            </div>
          </details>
        </section>

        <div className="contact">
          <h3>
            <span lang="en">Still need help?</span>
            <span lang="kn">ಇನ್ನೂ ಸಹಾಯ ಬೇಕೇ?</span>
          </h3>
          <p>
            <span lang="en">Email</span>
            <span lang="kn">ಇಮೇಲ್</span>: <a href="mailto:complaints@mybmtc.com">complaints@mybmtc.com</a>
          </p>
          <p>
            <span lang="en">Helpline</span>
            <span lang="kn">ಸಹಾಯವಾಣಿ</span>: <a href="tel:08022483777">080-22483777</a>
          </p>
        </div>
      </main>

      <footer>
        <span lang="en">Bangalore Metropolitan Transport Corporation · Namma BMTC App</span>
        <span lang="kn">ಬೆಂಗಳೂರು ಮಹಾನಗರ ಸಾರಿಗೆ ಸಂಸ್ಥೆ · ನಮ್ಮ BMTC ಆ್ಯಪ್</span>
      </footer>
    </div>
  )
}